<!-- Page 1 -->
<div class="pdf-page app-aul-015-24" id="aul01524">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>ORDINANCE OR LAW COVERAGE</b>
  </p>
  <p class="font-large">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY</b>
  </p>

  <p class="font-small mb-0">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small mb-0">BUILDING AND PERSONAL PROPERTY COVERAGE FORM</p>
  <p class="font-small">CONDOMINIUM ASSOCIATION COVERAGE FORM</p>
  <br />
  <p class="font-small" style="text-align: center"><b>Schedule</b></p>
  <p class="font-small">
    For each Covered Building at Covered Premises as described in the
    <b
      >Commercial Property Supplemental Declarations. The Following Coverages
      applies under this endorsement;</b
    >
  </p>
  <table class="font-small" style="width: 100%; border: 1px solid #000;border-collapse: collapse; width: 100%">
    <tbody>
      <tr>
        <td style="text-align: center; width: 25%; vertical-align: top; border: 1px solid black; padding: 5px">
          <p style="text-decoration: underline"><b>Coverage A</b></p>
        </td>
        <td style="text-align: center; width: 50%; vertical-align: top; border: 1px solid black; padding: 5px">
          <p style="text-decoration: underline">
            <b>Coverage B And C Combined Limit OF Insurance</b>
          </p>
          <p><b>20% of the Building Limit </b></p>
          <p>described in the Commercial Property Supplemental Declarations</p>
        </td>
        <td style="text-align: center; width: 25%; vertical-align: top; border: 1px solid black; padding: 5px">
          <p style="text-decoration: underline">
            <b>Post-Loss Ordinance or Law Option</b>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <ol class="font-small" style="list-style-type: upper-alpha">
    <!-- A -->
    <li>
      Each Coverage - Coverage <b>A</b>, Coverage <b>B</b> and Coverage
      <b>C</b> - is provided under this endorsement only if Ordinance or Law
      Coverage shown in the Commercial Property Supplemental Declarations as
      applicable at the Covered Premises.
    </li>
    <!-- B -->
    <li>
      <b>Application Of Coverage(s)</b><br />
      The Coverages provided by this endorsement applies with respect to an
      ordinance or law that regulates the demolition, construction or repair of
      buildings, or establishes zoning or land use requirements at the described
      premises, subject to the following:
      <ol>
        <li>
          The requirements of the ordinance or law are in force at the time of
          loss; or the ordinance or law is promulgated or revised after the loss
          but prior to commencement of reconstruction or repair and provided
          that such ordinance or law requires compliance as a condition
          precedent to obtaining a building permit or certificate of occupancy.
        </li>
        <li>
          Coverage under this endorsement applies only in response to the
          minimum requirements of the ordinance or law. Losses and costs
          incurred in complying with recommended actions or standards that
          exceed actual requirements are not covered under this endorsement.
        </li>
        <li>
          Coverage under this endorsement applies only if:
          <ol style="list-style-type: lower-alpha">
            <li>
              The building sustains only direct physical damage that is covered
              under this policy and as a result of such damage, you are required
              to comply with the ordinance or law; or
            </li>
            <li>
              The building sustains both direct physical damage that is covered
              under this policy and direct physical damage that is not covered
              under this policy, and as a result of the building damage in its
              entirety, you are required to comply with the ordinance or law.
            </li>
          </ol>
          However, there is no coverage under this endorsement if the building
          sustains direct physical damage that is not covered under this policy,
          and such damage is the subject of the ordinance or law, even if the
          building has also sustained covered direct physical damage.
        </li>
        <li>
          If coverage applies under this endorsement based on the terms of
          Paragraph <b>B.4.b.,</b> we will not pay the full amount of loss
          otherwise payable under the terms of Coverages <b>A, B,</b> and/or
          <b>C</b> of this endorsement. Instead, we will pay a proportion of
          such loss, meaning the proportion that the covered direct physical
          damage bears to the total direct physical damage.
          <i
            >(Paragraph F. of this endorsement provides an example of this
            procedure.)</i
          >
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 2 -->
<div class="font-small pdf-page app-aul-015-24">
  <ul style="list-style-type: none">
    <ul style="list-style-type: none">
      <li>
        However, if the covered direct physical damage, alone, would have
        resulted in a requirement to comply with the ordinance or law, then we
        will pay the full amount of loss otherwise payable under the terms of
        Coverages
        <b>A, B,</b> and/or <b>C</b> of this endorsement.
      </li>
    </ul>
    <ol start="5">
      <li>
        We will not pay under this endorsement for:
        <ol type="a">
          <li>
            Enforcement of or compliance with any ordinance or law which
            requires the demolition, repair, replacement, reconstruction,
            remodeling or remediation of property due to contamination by
            "pollutants" or due to the presence, growth, proliferation, spread
            or any activity of "fungus", wet or dry rot or bacteria; or
          </li>
          <li>
            The costs associated with the enforcement of or compliance with any
            ordinance or law which requires any insured or others to test for,
            monitor, clean up, remove, contain, treat, detoxify or neutralize,
            or in any way respond to, or assess the effects of "pollutants",
            "fungus", wet or dry rot or bacteria.
          </li>
        </ol>
      </li>
      <li>
        We will not pay under this endorsement for any loss in value or any cost
        incurred due to an ordinance or law that you were required to comply
        with before the time of the current loss, even in the absence of
        building damage, if you failed to comply.
      </li>
    </ol>
  </ul>
  <ol type="A" start="3">
    <!-- C -->
    <li>
      <b>Coverage</b>
      <ol>
        <!-- 1 -->
        <li>
          <b
            >Coverage A - Coverage For Loss To The Undamaged Portion Of The
            Building</b
          >
          <ul style="list-style-type: none">
            <li>
              With respect to the building that has sustained covered direct
              physical damage, we will pay under Coverage <b>A</b> for the loss
              in value of the undamaged portion of the building as a consequence
              of a requirement to comply with an ordinance or law that requires
              demolition of undamaged parts of the same building. Coverage
              <b>A</b> is included within the Limit Of Insurance applicable to
              such building as shown in the Declarations or addressed elsewhere
              in this policy. Coverage <b>A</b> does not increase the Limit of
              Insurance.
            </li>
          </ul>
        </li>
        <!-- 2 -->
        <li>
          <b>Coverage B - Demolition Cost Coverage</b>
          <ul style="list-style-type: none">
            <li>
              With respect to the building that has sustained covered direct
              physical damage, we will pay the cost to demolish and clear the
              site of undamaged parts of the same building as a consequence of a
              requirement to comply with an ordinance or law that requires
              demolition of such undamaged property.
            </li>
            <li>
              The Coinsurance Additional Condition does not apply to Demolition
              Cost Coverage.
            </li>
          </ul>
        </li>
        <!-- 3 -->
        <li>
          <b>Coverage C - Increased Cost Of Construction Coverage</b>
          <ol style="list-style-type: lower-alpha">
            <!-- a -->
            <li>
              With respect to the building that has sustained covered direct
              physical damage, we will pay the increased cost to:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> Repair or reconstruct damaged portions of that
                  building; and/or
                </li>
                <li>
                  <b>(2)</b> Reconstruct or remodel undamaged portions of that
                  building, whether or not demolition is required;
                </li>
                when the increased cost is a consequence of a requirement to
                comply with the minimum standards of the ordinance or law.
                However:
                <li>
                  <b>(1)</b> This coverage applies only if the restored or
                  remodeled property is intended for similar occupancy as the
                  current property, unless such occupancy is not permitted by
                  zoning or land use ordinance or law.
                </li>
                <li>
                  <b>(2)</b> We will not pay for the increased cost of
                  construction if the building is not repaired, reconstructed or
                  remodeled.
                </li>
              </ul>
              The Coinsurance Additional Condition does not apply to Increased
              Cost of Construction Coverage.
            </li>
          </ol>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 3 -->
<div class="font-small pdf-page app-aul-015-24">
  <ul style="list-style-type: none">
    <li>
      <ol type="a" start="2">
        <!-- b -->
        <li>
          When a building is damaged or destroyed and Coverage
          <b>C</b> applies to that building in accordance with Paragraph
          <b>C.3.a.</b> above, coverage for the increased cost of construction
          also applies to repair or reconstruction of the following, subject to
          the same conditions stated in Paragraph
          <b>C.3.a.:</b>
          <ul style="list-style-type: none">
            <li>
              <b>(1)</b> The cost of excavations, grading, backfilling and
              filling;
            </li>
            <li><b>(2)</b> Foundation of the building;</li>
            <li><b>(3)</b> Pilings; and</li>
            <li>
              <b>(4)</b> Underground pipes, flues and drains. The items listed
              in <b>b.(1)</b> through <b>b.(4)</b> above are deleted from
              Property Not Covered, but only with respect to the coverage
              described in this provision, <b>3.b.</b>
            </li>
          </ul>
        </li>
      </ol>
    </li>
  </ul>
  <ol type="A" start="4">
    <!-- D -->
    <li>
      <b>Loss Payment</b>
      <ol>
        <li>
          All following loss payment provisions, <b>D.2.</b> through
          <b>D.5.,</b> are subject to the apportionment procedures set forth in
          Paragraph <b>B.5.</b> of this endorsement.
        </li>
        <li>
          When there is a loss in value of an undamaged portion of a building to
          which Coverage <b>A</b> applies, the loss payment for that building,
          including damaged and undamaged portions, will be determined as
          follows:
          <ol style="list-style-type: lower-alpha">
            <li>
              If the Replacement Cost Coverage Option applies and such building
              is being repaired or replaced, on the same or another premises, we
              will not pay more than the lesser of:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> The amount you would actually spend to repair,
                  rebuild or reconstruct such building, but not for more than
                  the amount it would cost to restore the building on the same
                  premises and to the same height, floor area, style and
                  comparable quality of the original property insured; or
                </li>
                <li>
                  <b>(2)</b> The Limit Of Insurance applicable to such building
                  as shown in the Declarations or addressed elsewhere in this
                  policy. (If this policy is endorsed to cover Earthquake and/or
                  Flood as a Covered Cause of Loss, the Limit of Insurance
                  applicable to the building in the event of damage by such
                  Covered Cause of Loss may be lower than the Limit of Insurance
                  that otherwise would apply.)
                </li>
              </ul>
            </li>
            <li>
              If the Replacement Cost Coverage Option applies and such building
              is not repaired or replaced, or if the Replacement Cost Coverage
              Option does not apply, we will not pay more than the lesser of:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> The actual cash value of such building at the time
                  of loss; or
                </li>
                <li>
                  <b>(2)</b> The Limit Of Insurance applicable to such building
                  as shown in the Declarations or addressed elsewhere in this
                  policy. (If this policy is endorsed to cover Earthquake and/or
                  Flood as a Covered Cause of Loss, the Limit of Insurance
                  applicable to the building in the event of damage by such
                  Covered Cause of Loss may be lower than the Limit of Insurance
                  that otherwise would apply.)
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          Unless Paragraph <b>D.5.</b> applies, loss payment under Coverage
          <b>B</b> - Demolition Cost Coverage will be determined as follows:
          <br />
          We will not pay more than the lesser of the following:
          <ol style="list-style-type: lower-alpha">
            <li>
              The amount you actually spend to demolish and clear the site of
              the described premises; or
            </li>
            <li>
              The applicable Limit Of Insurance shown for Coverage <b>B</b> in
              the Schedule.
            </li>
          </ol>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 4 -->
<div class="font-small pdf-page app-aul-015-24">
  <ul style="list-style-type: none">
    <li>
      <ol start="4">
        <!-- 4 -->
        <li>
          Unless Paragraph <b>D.5.</b> applies, loss payment under Coverage
          <b>C</b> - Increased Cost Of Construction Coverage will be determined
          as follows:
          <ol style="list-style-type: lower-alpha">
            <!-- a -->
            <li>
              We will not pay under Coverage <b>C</b>:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> Until the building is actually repaired or
                  replaced, at the same or another premises; and
                </li>
                <li>
                  <b>(2)</b> Unless the repair or replacement is made as soon as
                  reasonably possible after the loss or damage, not to exceed
                  two years. We may extend this period in writing during the two
                  years.
                </li>
              </ul>
            </li>
            <!-- b -->
            <li>
              If the building is repaired or replaced at the same premises, or
              if you elect to rebuild at another premises, the most we will pay
              under Coverage <b>C</b> is the lesser of:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> The increased cost of construction at the same
                  premises; or
                </li>
                <li>
                  <b>(2)</b> The applicable Limit Of Insurance shown for
                  Coverage <b>C</b> in the Schedule.
                </li>
              </ul>
            </li>
            <!-- c -->
            <li>
              If the ordinance or law requires relocation to another premises,
              the most we will pay under Coverage <b>C</b> is the lesser of:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> The increased cost of construction at the new
                  premises; or
                </li>
                <li>
                  <b>(2)</b> The applicable Limit Of Insurance shown for
                  Coverage C in the Schedule.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <!-- 5 -->
        <li>
          If a Combined Limit Of Insurance is shown for Coverages <b>B</b> and
          <b>C</b> in the Schedule, Paragraphs <b>D.3.</b> and <b>D.4.</b> do
          not apply with respect to the building that is subject to the Combined
          Limit, and the following loss payment provisions apply instead:
          <p>
            The most we will pay, for the total of all covered losses for
            Demolition Cost and Increased Cost of Construction, is the Combined
            Limit Of Insurance shown for Coverages <b>B</b> and <b>C</b> in the
            Schedule. Subject to this Combined Limit of Insurance, the following
            loss payment provisions apply:
          </p>
          <ol style="list-style-type: lower-alpha">
            <li>
              For Demolition Cost, we will not pay more than the amount you
              actually spend to demolish and clear the site of the described
              premises.
            </li>
            <li>
              With respect to the Increased Cost of Construction:
              <ul style="list-style-type: none">
                <li>
                  <b>(1)</b> We will not pay for the increased cost of
                  construction:
                  <ul style="list-style-type: none">
                    <li>
                      <b>(a)</b> Until the building is actually repaired or
                      replaced, at the same or another premises; and
                    </li>
                    <li>
                      <b>(b)</b> Unless the repair or replacement is made as
                      soon as reasonably possible after the loss or damage, not
                      to exceed two years. We may extend this period in writing
                      during the two years.
                    </li>
                  </ul>
                </li>
                <li>
                  <b>(2)</b> If the building is repaired or replaced at the same
                  premises, or if you elect to rebuild at another premises, the
                  most we will pay for the increased cost of construction is the
                  increased cost of construction at the same premises.
                </li>
                <li>
                  <b>(3)</b> If the ordinance or law requires relocation to
                  another premises, the most we will pay for the increased cost
                  of construction is the increased cost of construction at the
                  new premises.
                </li>
              </ul>
            </li>
          </ol>
        </li>
      </ol>
    </li>
  </ul>
</div>

<!-- Page 5 -->
<div class="font-small pdf-page app-aul-015-24">
  <ol type="A" start="5">
    <!-- E -->
    <li>
      The terms of this endorsement apply separately to each building to which
      this endorsement applies.
    </li>
    <!-- F -->
    <li>
      Example of proportionate loss payment for Ordinance Or Law Coverage Losses
      (procedure as set forth in Paragraph <b>B.5.</b>).
      <p>Assume:</p>
      <ul style="list-style-type: none">
        <li>
          Wind is a Covered Cause of Loss; Flood is an excluded Cause of Loss
        </li>
        <li>The building has a value of $200,000</li>
        <li>Total direct physical damage to building: $100,000</li>
        <li>
          The ordinance or law in this jurisdiction is enforced when building
          damage equals or exceeds 50% of the building's value
        </li>
        <li>
          Portion of direct physical damage that is covered (caused by wind):
          $30,000
        </li>
        <li>
          Portion of direct physical damage that is not covered (caused by
          flood): $70,000
        </li>
        <li>
          Loss under Ordinance Or Law Coverage C of this endorsement: $60,000
        </li>
      </ul>
      <p>
        <b>Step 1:</b> Determine the proportion that the covered direct physical
        damage bears to the total direct physical damage. $30,000 ÷ $100,000 =
        .30
      </p>
      <p>
        <b>Step 2:</b> Apply that proportion to the Ordinance or Law loss.
        $60,000 x .30 = $18,000 In this example, the most we will pay under this
        endorsement for the Coverage C loss is $18,000, subject to the
        applicable Limit of Insurance and any other applicable provisions.
      </p>
      <p>
        <b>Note:</b> The same procedure applies to losses under Coverages A and
        B of this endorsement.
      </p>
    </li>
    <!-- G -->
    <li>
      The following definition is added:
      <br />
      "Fungus" means any type or form of fungus, including mold or mildew, and
      any mycotoxins, spores, scents or by-products produced or released by
      fungi.
    </li>
  </ol>
</div>
